import { ReactNode } from "react";

interface PageTitleProps {
  children: ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

export default function PageTitle({
  children,
  className = "",
  size = "lg",
}: PageTitleProps) {
  const sizeClasses = {
    sm: "text-xl font-normal",
    md: "text-2xl font-semibold",
    lg: "text-3xl font-semibold",
    xl: "text-4xl font-semibold",
  };

  const baseClasses = "text-black mb-2";
  const classes = `${baseClasses} ${sizeClasses[size]} ${className}`;

  return <h1 className={classes}>{children}</h1>;
}
